import { useEffect, FC, useState } from "react";
// echarts and china maps
import * as echarts from "echarts";
import { Divider, Form } from "antd";
import { Card } from "./components/Card";
import defalutMapData from "../json/_china";
import {
  getCountryLearnView,
  getCountryLearnEchartData,
} from "@root/common/service";
import SubjectSelect from "@root/components/selectBox/subjectSelect";
type EChartsOption = echarts.EChartsOption;
console.log("echarts", echarts);

const China: FC = () => {
  const [cardArray, setCardArray] = useState<any[]>([]);
  async function getCountryViewData(subject?: number | undefined) {
    const {
      data: {
        instituteDataInfo,
        userDataInfo = { userCount: 0 },
        learnRecordInfo,
        learnCourseInfo,
      },
    } = await getCountryLearnView({ subjectId: subject });
    const {
      data: { globalViewMapDataList },
    } = await getCountryLearnEchartData({ subjectId: subject });
    const {
      countyHospitalCount,
      supportHospitalCount,
      recipientHospitalCount,
      instituteCount,
    } = instituteDataInfo;
    const { userCount } = userDataInfo;
    const { learnUserCount, learnRatio, watchTime, averageWatchTime } =
      learnRecordInfo;
    const {
      totalCourseCount,
      countryCourseCount,
      supportHospitalCourseCount,
      recipientHospitalCourseCount,
    } = learnCourseInfo;
    let initCardArray = [
      {
        name: "机构数量",
        subtitles: [
          {
            name: "机构总数",
            number: instituteCount,
          },
          {
            name: "县医院总数",
            number: countyHospitalCount,
          },
          // {
          //   name: "受援医院数量",
          //   number: recipientHospitalCount,
          // },
        ],
      },
      {
        name: "人数统计",
        subtitles: [
          {
            name: "注册总人数",
            number: userCount,
          },
          {
            name: "学习人数",
            number: learnUserCount,
          },
        ],
      },
      {
        name: "课程统计",
        subtitles: [
          {
            name: "课程总数",
            number: totalCourseCount,
          },
          {
            name: "国家级课程数",
            number: countryCourseCount,
          },
          // {
          //   name: "支援医院课程数",
          //   number: supportHospitalCourseCount,
          // },
          // {
          //   name: "受援医院课程数",
          //   number: recipientHospitalCourseCount,
          // },
        ],
      },
      {
        name: "学习统计",
        subtitles: [
          {
            name: "培训率",
            number: `${learnRatio}%`,
          },
          {
            name: "学习时长(小时)",
            number: watchTime,
          },
          {
            name: "平均学习时长(小时)",
            number: averageWatchTime,
          },
        ],
      },
    ];
    setCardArray([...initCardArray]);
    getEcharts(globalViewMapDataList);
  }
  useEffect(() => {
    getCountryViewData();
  }, []);
  // 渲染echarts
  const getEcharts = (interfaceMapData: any[]) => {
    var chartDom: any = document.getElementById("MAP");
    var myChart = echarts.init(chartDom);
    var nameMap = "地图数据";
    var mapData: any = [];
    //@ts-ignore
    echarts.registerMap(nameMap, defalutMapData);
    /*获取地图数据*/
    myChart.showLoading();
    var mapFeatures = echarts.getMap(nameMap).geoJson.features;
    console.log("mapFeatures", mapFeatures);
    myChart.hideLoading();
    mapFeatures.forEach(function (v: any, index: number) {
      // 地区名称
      mapData.push({
        name: v.properties.name,
        value: Math.random() * 100,
      });
    });
    var serverdata = [
      {
        // 地图块的相关信息
        type: "map",
        map: nameMap,
        zoom: 1.2,
        roam: false,
        selectedMode: "single",
        showLegendSymbol: false,
        visibility: "off",
        label: {
          show: false,
          normal: {
            show: true,
            textStyle: {
              fontSize: 12,
              fontWeight: 400,
              color: "#fff",
            },
          },
        },
        data: mapData,
      },
    ];
    var optionMap = {
      tooltip: {
        trigger: "item",
        formatter: function (params: any) {
          const { name } = params;
          console.log("mapFeatures", mapFeatures);
          console.log("name", name);

          const {
            instituteCount,
            userCount,
            countyHospitalCount,
            learnUserCount,
            learnRatio,
          } = interfaceMapData.find((item: any) =>
            name.includes(item.provinceName)
          );
          let str: string = "";
          str += `机构数量: ${instituteCount} <br/>`;
          str += `县医院数量:  ${countyHospitalCount} <br/>`;
          str += `注册人数: ${userCount} <br/>`;
          str += `学习人数: ${learnUserCount} <br/>`;
          str += `培训率: ${learnRatio}% <br/>`;
          return str;
        },
      },
      visualMap: {
        type: "piecewise",
        pieces: [
          { max: 30, label: "安全", color: "orange" },
          { min: 30, max: 60, label: "警告", color: "#4575b4" },
          { min: 60, label: "危险", color: "#74add1" },
        ],
        color: "#fff",
        textStyle: {
          color: "#fff",
        },
        visibility: "off",
      },
      series: serverdata,
    };
    myChart.setOption(optionMap);
  };
  const onSelectChangeHandle = (value: any) => {
    if (value === "all") {
      value = undefined;
    }

    getCountryViewData(value);
  };

  return (
    <div className="summarize">
      <div className="summarize-wrapper">
        <Form>
          <SubjectSelect
            label={false}
            showAll={true}
            styles={{ width: 160 }}
            onSelect={(value) => {
              onSelectChangeHandle(value);
            }}
          />
        </Form>
        <Divider />
        <div className="summarize-card-wrapper">
          {cardArray.map((item, index) => {
            return (
              <Card key={index} name={item.name} subtitle={item.subtitles} />
            );
          })}
        </div>
        <div id="MAP"></div>
      </div>
    </div>
  );
};

export default China;
